<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.OriginFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'OriginFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      return [{
        text: this.$t('components.filters.OriginFilter.items.listening'),
        value: DATA_TYPE.LISTENING,
      },
      {
        text: this.$t('components.filters.OriginFilter.items.sac'),
        value: DATA_TYPE.SAC,
      },
      {
        text: this.$t('components.filters.OriginFilter.items.smartCare'),
        value: DATA_TYPE.SAC_STATUS,
      },
      {
        text: this.$t('components.filters.OriginFilter.items.competitive'),
        value: DATA_TYPE.COMPETITIVE,
      }];
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}
</style>
